import cx from "classnames";
import React, { useState, MouseEvent, useRef, useEffect } from "react";

import { TableCellBlock } from "../../types";
import { guessFontSize } from "./ZoneUtils";
import { Cell } from "../InnodomContent/Table/Cell";
import { extractHumanReadableText, extractTextBlock } from "../InnodomContent/util";

type Props = Readonly<{
  cell: TableCellBlock;
  gutter: number;
  onSelectCell: (blockId: string, textContent: string, replace: boolean) => void;
  onShowReferences: (zoneId: string) => void;
  scale: number;
  selected: boolean;
}>;

const TableCellZoneComponent = ({
  cell,
  gutter,
  onSelectCell,
  onShowReferences,
  scale,
  selected,
}: Props) => {
  const style = {
    height: cell.height * scale,
    left: cell.x * scale + gutter,
    top: cell.y * scale,
    width: cell.width * scale,
  };
  const [editorVisible, setEditorVisble] = useState(false);
  const ref: any = useRef();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setEditorVisble(false);
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    }
  }, []);

  return (
    <div>
      <div
        className={cx("zone", "zone-cell", cell.confidenceClass, { selected })}
        id={cell.id}
        onClick={e => {
          if (e.altKey) {
            setEditorVisble(!editorVisible);
            return;
          }
          e.preventDefault();
          if (e.shiftKey && cell.references.length > 0) {
            onShowReferences(cell.id);
            return;
          }
          onSelectCell(cell.id, cell.element.textContent || "", e.ctrlKey);
        }}
        style={style}
      >
      </div>

      {editorVisible && 
        <div
          ref={ref}
          style={{
            ...style,
            userSelect: "text",
            top: style.top + style.height,
            left: style.left - 41, // Make room for the edit button
            width: style.width + 41,
            height: 1.2 * style.height + 20, // Bit of a buffer
            resize: "none",
            fontSize:  guessFontSize(cell.text, style.height, style.width) + "px",
            position:"absolute",
            backgroundColor:"white",
            border: "1px solid black",
            paddingLeft:10,
            paddingRight:10,
            display:"flex",
            alignItems:"center",
            zIndex: 10000
          }}>
          <div
            className={cx({ selected: selected }, cell.confidenceClass)}
            onClick={
              (e: MouseEvent<HTMLElement>) => {
                e.preventDefault();
                e.stopPropagation();
                onSelectCell(cell.id, extractHumanReadableText(cell.element), e.ctrlKey);
              }
            }
          >
            {extractTextBlock(cell.element, cell.highlights)}
          </div>
        </div>
      }

    </div>
  );
};
TableCellZoneComponent.displayName = "TableCellZone";
export const TableCellZone = React.memo(TableCellZoneComponent);
